<div class="news-notice">
    <div>알림</div>
    <table>
        <thead>
            <th>번호</th>
            <th>제목</th>
            <th>등록일</th>
        </thead>
        <tbody>
            <tr class="none">
                <td></td>
                <td><span>아이로브 소식을 준비중입니다. </span></td>
                <td></td>
            </tr>
        </tbody>
    </table>
</div>